import React, { useState, useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import { Accordion, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  ContainerType,
  ItemCard,
  TextCard,
  ItemDropDown,
  SelectBranches,
  ErrorMessage
} from "./styles";
import { CardHeader } from "~/pages/Order/styles";
import "~/components/styles/Global.css";
import mapa from "~/assets/images/mapa.svg";

import { analytics, logEvent }  from "~/services/firebaseConfig";
import Datepicker from "~/components/layout/DatepickerField";

export default function OrderType(props) {
  const [branch, setBranch] = useState(
    props.filiais[0] ? props.filiais[0] : ""
  );
  const [orderNormal, setOrderNormal] = useState(false);
  const [orderTake, setOrderTake] = useState(false);
  const [showDatepicker, setShowDatepicker] = useState(false);
  const [hasntTheProduct, setHasntTheProduct] = useState(false);
  const [productsEdited, setProductsEdited] = useState([]);

  const selectedBranch = useSelector(
    (state) => state.orderReducer.selectedBranch
  );
  const items = useSelector((state) => state.orderReducer.items);
  const orderReducer = useSelector((state) => state.orderReducer);
  const orderEditReducer = useSelector((state) => state.orderEditReducer);

  const dispatch = useDispatch();

  function editOrder(typeOrder) {
    dispatch({
      type: "EDIT_SUMMARY",
      typeOrder,
      branch: branch,
    });
  }

  function selectBranch(branchIndex) {
    localStorage.setItem("supplyBranchId", props.filiais[branchIndex].id);
    dispatch({
      type: "SELECT_BRANCH",
      selectedBranch: branchIndex,
    });
  }

  useEffect(() => {
    if(orderReducer.orderTake) {
      setOrderTake(true);
    }
  }, []);

  useEffect(() => {
    if(hasntTheProduct) {
      props.setDisableButton(true);
      props.setMessageErrorProduct(true);
    } else {
      props.setMessageErrorProduct(false);
    }
  }, [hasntTheProduct]);

  useEffect(() => {
    if(hasntTheProduct) {
      setHasntTheProduct(false);
      let arrayOfProducts = [];
      props.filiais.map((branch, index) => {
        orderEditReducer.orders.map((productChoosed) => {
          branch.products.map((product) => {
            if(productChoosed.code === product.code) {
              arrayOfProducts.push(product)
            }
          })
        })
      });
      if(orderEditReducer.orders.length > 0) {
        let arrayProductsEdited = [];
        orderEditReducer.orders.map((orderProduct) => {
          arrayOfProducts.map((product) => {
            if(orderProduct.code !== product.code) {
              arrayProductsEdited.push(orderProduct)
            }
          })
        })
        let resultArrayProducts = [];
        arrayProductsEdited.forEach((item) => {
          if(resultArrayProducts.indexOf(item) < 0) {
            resultArrayProducts.push(item);
          }
        });
        let arrayFinalProducts = [];
        props.filiais[selectedBranch].products.map((branchProduct) => {
          resultArrayProducts.map((productInList) => {
            if(productInList.code === branchProduct.code) {
              arrayFinalProducts.push(productInList);
            }
          })
        })
        let wrongProducts = [];
        resultArrayProducts.map((product) => {
          arrayFinalProducts.map((productFinal) => {
            if(product.code !== productFinal.code) {
              wrongProducts.push(product)
            }
          })
        })
        if(wrongProducts.length === 0 &&
        resultArrayProducts.length === orderEditReducer.orders.length) {
          wrongProducts = orderEditReducer.orders
        }
        if(resultArrayProducts.length === 0) {
          if(wrongProducts.length === 0 &&
            arrayOfProducts.length === orderEditReducer.orders.length) {
            wrongProducts = orderEditReducer.orders
          }
        }
        setProductsEdited(wrongProducts);
        let lengthProducts = wrongProducts.concat(arrayFinalProducts);
        if(lengthProducts.length === orderEditReducer.orders.length) {
          setHasntTheProduct(true)
          props.setDisableButton(false);
        }
      }
    }
  }, [orderEditReducer.deletedItem]);

  return (
    <ContainerType>
      <Accordion>
        <Card.Header style={CardHeader}>Tipo de pedido</Card.Header>
        <Card>
          {localStorage.getItem("standardServiceType") === "RETIRA" ? (
            <>
              <Card>
                <ItemCard
                  onClick={() => {
                    setOrderTake(true);
                    if (orderNormal) {
                      setOrderNormal(false);
                    }
                    editOrder("Retira");
                    dispatch({ type: "SET_ORDER_TAKE", orderTake: true });
                  }}
                >
                  <img src={mapa} alt="Ícone de retirada de pedido" />
                  <TextCard>Retira</TextCard>
                  <div />
                </ItemCard>
              </Card>
              <div>
                <div style={{ height: showDatepicker ? 585 : "auto" }}>
                  <ItemDropDown>
                    <TextCard padding={`1rem 1rem .3rem 1rem`}>
                      Selecione Filial Abastecedora
                    </TextCard>
                    <SelectBranches
                      margin={"0rem .75rem 1.3rem .7rem"}
                      onChange={(event) => {
                        if(props.openItems) {
                          props.setOpenItems(false)
                        }
                        dispatch({ type: 'ADD_PRODUCT', products: [] });
                        setHasntTheProduct(false);
                        let arrayOfProducts = [];
                        props.filiais.map((branch, index) => {
                          if(branch.name === event.target.value &&
                            orderEditReducer.orders.length > 0) {
                            orderEditReducer.orders.map((productChoosed) => {
                              branch.products.map((product) => {
                                if(productChoosed.code === product.code) {
                                  arrayOfProducts.push(product)
                                }
                              })
                            })
                            if(orderEditReducer.orders.length > 0) {
                              var arrayProductsEdited = orderEditReducer.orders.filter(function(objOne) {
                                return !arrayOfProducts.some(function(objTwo) {
                                    return objOne.code === objTwo.code;
                                });
                              });
                              setProductsEdited(arrayProductsEdited.length === 0 ?
                              orderEditReducer.orders : arrayProductsEdited);
                              if(arrayOfProducts.length !== orderEditReducer.orders.length) {
                                setHasntTheProduct(true)
                              }
                            }
                          }
                          if(branch.name === event.target.value) {
                            dispatch({ type: "CHANGE_BRANCH" });
                            orderEditReducer.supplyBranches.map((item) => {
                              if(branch.name === item.name) {
                                dispatch({ type: 'ADD_PRODUCT', products: item.products });
                              }
                            });
                            props.setDisableButton(false);
                            selectBranch(index);
                            logEvent(analytics, 'troca_filial');
                          }
                        });
                      }}
                    >
                      {props.filiais.map((element, index) => (
                        <option
                          element={element}
                          key={element.id}
                          selected={selectedBranch === index}
                        >
                          {element.name}
                        </option>
                      ))}
                    </SelectBranches>
                    {
                      hasntTheProduct ? (
                        <ErrorMessage>
                          <span>
                            Um ou mais produtos não são disponibilizados na filial selecionada.
                            Para prosseguir com a edição do pedido, exclua {productsEdited.length === 1 ?
                            <>o produto </> : <>os produtos </>}
                            {
                              productsEdited.length === 1 ? (
                                <>
                                  {
                                    productsEdited.map((product) => <>{product.name}</>)
                                  }
                                </>
                              ) : (
                                <>
                                  {
                                    productsEdited.map((product, index) => {
                                      if(index === 0) {
                                        return <>{product.name}</>
                                      } else if(index === productsEdited.length - 1) {
                                        return <> e {product.name}</>
                                      } else {
                                        return <>, {product.name}</>
                                      }
                                    })
                                  }
                                </>
                              )
                            }
                          </span>
                        </ErrorMessage>
                      ) : null
                    }
                  </ItemDropDown>
                  <ItemDropDown>
                    <TextCard padding={`1rem 1rem .3rem 1rem`}>
                      Data de Carregamento
                    </TextCard>
                    <Datepicker
                      edit={true}
                      setShowDatepicker={setShowDatepicker}
                      setDisableButton={props.setDisableButton}
                    />
                  </ItemDropDown>
                </div>
              </div>
            </>
          ) : (
            <>
              <Card>
                <ItemCard
                  onClick={() => {
                    setOrderTake(true);
                    if (orderNormal) {
                      setOrderNormal(false);
                    }
                    editOrder("Entrega");
                    dispatch({ type: "SET_ORDER_TAKE", orderTake: true });
                  }}
                >
                  <img src={mapa} alt="Ícone de entrega de pedido" />
                  <TextCard>Entrega</TextCard>
                  <div />
                </ItemCard>
              </Card>
              <div>
                <div style={{ height: showDatepicker ? 585 : "auto" }}>
                  <ItemDropDown>
                    <TextCard padding={`1rem 1rem .3rem 1rem`}>
                      Data de Carregamento
                    </TextCard>
                    <Datepicker
                      edit={true}
                      setShowDatepicker={setShowDatepicker}
                      setDisableButton={props.setDisableButton}
                    />
                  </ItemDropDown>
                </div>
              </div>
            </>
          )}
        </Card>
      </Accordion>
    </ContainerType>
  );
}
